import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import { Typography, Box, Button, GRAY } from '@applyboard/ui-components';
import { Card } from "../Card";
import { GradeEligibilityModal } from '..';
import { convertToFloat } from "./utils";
export function AcademicBackground(_ref) {
  var levelText = _ref.levelText,
    minGpa = _ref.minGpa,
    programId = _ref.programId,
    disableModal = _ref.disableModal;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var onClickConvertGrades = useCallback(function () {
    setModalOpen(true);
    trackEvent({
      event: "Programs Page - Clicked 'Convert grades'"
    });
  }, [setModalOpen, trackEvent]);
  var onCloseModal = useCallback(function () {
    return setModalOpen(false);
  }, [setModalOpen]);
  if (!levelText && !minGpa) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!minGpa && !disableModal && /*#__PURE__*/React.createElement(GradeEligibilityModal, {
    programId: programId,
    minGpa: minGpa,
    open: modalOpen,
    onClose: onCloseModal
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    mb: 3,
    style: {
      color: GRAY[10]
    }
  }, "Academic Background"), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start"
  }, levelText ? /*#__PURE__*/React.createElement(Card, {
    header: /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        color: GRAY[10]
      }
    }, "Minimum Level of Education Completed")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    style: {
      color: GRAY[5]
    }
  }, levelText)) : null, !!minGpa && /*#__PURE__*/React.createElement(Card, {
    header: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        color: GRAY[10]
      }
    }, "Minimum GPA"), /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      ml: "auto",
      p: "0 4px",
      onClick: onClickConvertGrades
    }, "Convert grades"))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    style: {
      color: GRAY[5]
    }
  }, convertToFloat(minGpa).toFixed(1), "%"))));
}